// extracted by mini-css-extract-plugin
export default {"foto":"FotoB_foto__w37kn"};